import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchHouseDetail, fetchMeterList } from '@/api/PMS/houseDeliveryManage/deliveryRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: {
    showDialog: Boolean,
    deliveryObj: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      queryMeter: {
        houseStatus: 1
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }],
        statusDate: [{
          required: true,
          message: '请选择接房日期',
          trigger: 'change'
        }]
      },
      loading: false,
      customerList: [],
      cascaderItem: [],
      houseList: [],
      list: [],
      childData: {},
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.loadMenuTree();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.list = [];
      this.customerList = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (Object.keys(this.deliveryObj).length > 0) {
        this.childData = this.deliveryObj;
        this.queryMeter.houseStatus = 2;
        this.getMeterList(this.childData.houseId);
      } else {
        this.queryMeter.houseStatus = 1;
        this.childData = {};
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 0,
        resourceType: 1
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this3 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this3.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    // 检查是否选择下拉框是否选择正确的房间
    checkSelectHouse: function checkSelectHouse() {
      this.cascaderItem = [];
      this.$set(this.childData, 'customerName', '');
      this.$set(this.childData, 'customerId', '');
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '211') {
        this.$message({
          message: '请选择正确的房间',
          type: 'error',
          duration: 3000
        });
        this.childData.upIdList = [];
        return false;
      }

      var houseId = this.childData.upIdList[this.childData.upIdList.length - 1];
      this.$set(this.childData, 'houseId', houseId);
      this.handleSelectHouse(houseId);
      this.getMeterList(houseId);
    },
    handleSelectHouse: function handleSelectHouse(houseId) {
      var _this4 = this;

      this.$set(this.childData, 'customerId', '');
      this.$set(this.childData, 'houseUseArea', '');
      fetchHouseDetail({
        houseId: houseId
      }).then(function (res) {
        if (res.data.code === 200) {
          _this4.$set(_this4.childData, 'customerId', res.data.data.customerId);

          _this4.$set(_this4.childData, 'houseUseArea', res.data.data.houseUseArea);
        }
      });
    },
    getMeterList: function getMeterList(id) {
      var _this5 = this;

      this.queryMeter.id = id;
      fetchMeterList(this.queryMeter).then(function (res) {
        if (res.data.code === 200) {
          _this5.list = res.data.data.houseMeterDetailListVos;

          _this5.$set(_this5.childData, 'userName', res.data.data.userName);
        }
      });
    },
    handUpdate: function handUpdate() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this6.childData.houseStatus = 2;

          if (Object.keys(_this6.deliveryObj).length > 0) {
            fetchUpdate(_this6.childData).then(function () {
              _this6.$emit('handCancle', true);

              _this6.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this6.childData).then(function (res) {
              if (res.data.code === 200) {
                _this6.$emit('handCancle', true);

                _this6.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'binding');
    }
  }
};